import React from 'react';
import { Field, RadioGroup } from '../../../../Core';
import { ListFieldSection, FieldSet, PageSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { AdditionalVisualDescription } from 'Components/Worksheets/Core/Fields';

let PreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const allowVisualDescriptionEntry = useSelector(
    createWorksheetSelector!('Preparation.AllowAdditionalVisualDescriptionEntry')
  );
  return (
    <PageSection heading="Preparation">
      <ListFieldSection>
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Preparation"
            name="Preparation.PreparationMethod"
            options={['None', 'Air Dried'].map((e) => ({ label: e, value: e }))}
            defaultValue="None"
          />
        </FieldSet>
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Method"
            name="Preparation.CompactionMethod.Id"
            options={[
              { label: 'ARIZ 225 (Method A)', value: 'A' },
              { label: 'ARIZ 245 (Method D)', value: 'D' },
            ]}
          />
        </FieldSet>
        <AdditionalVisualDescription editable visible={allowVisualDescriptionEntry} appendNamePrefix="Preparation" />
      </ListFieldSection>
    </PageSection>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
